import { TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import TogglingFilters from '@/creditflowresearch/ui/common/components/TogglingFilters';
import { getDealIds } from '@/creditflowresearch/ui/components/deals/DealListTable/components/HeaderActions';
import { useDealStatusContext } from '@/creditflowresearch/application/Deal/contexts/DealStatusContext';
import { useCorporateMarketPageContext } from '@/creditflowresearch/application/Deal/contexts/IssueTile/CorporateMarketPageContext';
import Links from '@/creditflowresearch/ui/components/deals/DealListTable/components/HeaderActions/Links';

import headerActionsStyles from '@/creditflowresearch/ui/components/deals/DealListTable/components/HeaderActions/headerActions.module.scss';

export interface IDealsHeaderProps {
  title?: React.ReactNode,
  children?: React.ReactNode,
}

const CorporateMarketDealHeader = ({
  title = 'Recent New Issue',
  children,
}: IDealsHeaderProps): React.ReactElement => {
  const { collection, isFetching } = useCorporateMarketPageContext();
  const { filterStatusSet, applyDealStatus } = useDealStatusContext();
  const dealIds = getDealIds(collection);
  const noData = !dealIds?.length && !isFetching;
  const isAllStatusesSelected = filterStatusSet.dealStatus.items.every((item) => item.isActive);

  return (
    <>
      <TileHeader
        title={ <Title title={ title } /> }
        dataTest="dealTileHeader"
      >
        <Flex
          align={ { sm: 'stretch', md: 'center', xl: 'center' } }
          direction={ { sm: 'column', md: 'row' } }
          gap={ 10 }
        >
          <div className={ headerActionsStyles.dealStatusFiltersWrapper }>
            <TogglingFilters
              isDisabled={ noData && isAllStatusesSelected }
              applyFilter={ applyDealStatus }
              filterSet={ filterStatusSet }
              isTooltipEnabled={ false }
              activeClassName={ headerActionsStyles.dealStatusFiltersActive }
            />
          </div>
          <Flex align={ { sm: 'baseline', md: 'center', xl: 'center' } } gap={ 10 } wrap={ { sm: 'wrap', md: 'wrap' } }>
            <Links />
          </Flex>
        </Flex>
      </TileHeader>
      { children }
    </>
  );
};

export default CorporateMarketDealHeader;
